export function objectStore(key, storageProvider) {
  const sessionStore = storageProvider(key)
  const object = sessionStore.get() || {}

  return {
    get(key) {
      if (key === undefined) {
        return object
      } else {
        return object[key]
      }
    },

    set(key, value) {
      object[key] = value
      sessionStore.set(object)
      return value
    },

    delete(key) {
      const value = this.get(key)
      delete object[key]
      sessionStore.set(object)
      return value
    },
  }
}
